/* LEKKA mega menu: open on hover (mouse) and click/tap, smooth open/close, one open at a time. */
(function () {
  if (window.__lkMegaMenu) return;
  window.__lkMegaMenu = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 220;
  var ANIM_MS = 200;

  function all() {
    return Array.prototype.slice.call(document.querySelectorAll('details.lk-mega'));
  }

  function setExpanded(d, value) {
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', value ? 'true' : 'false');
  }

  function closeNow(d) {
    clearTimeout(d._lkAnim);
    d.classList.remove('is-closing', 'is-switching');
    if (d.open) d.open = false;
    setExpanded(d, false);
  }

  function close(d) {
    if (!d.open || d.classList.contains('is-closing')) return;
    if (reduceMotion.matches) return closeNow(d);
    d.classList.add('is-closing');
    setExpanded(d, false);
    d._lkAnim = setTimeout(function () {
      closeNow(d);
    }, ANIM_MS);
  }

  function open(d) {
    clearTimeout(d._lkAnim);
    clearTimeout(d._lkLeave);
    var switching = false;
    all().forEach(function (o) {
      if (o !== d && o.open) {
        switching = true;
        closeNow(o);
      }
    });
    if (d.classList.contains('is-closing')) {
      d.classList.remove('is-closing');
      setExpanded(d, true);
      return;
    }
    if (d.open) return;
    if (switching) {
      d.classList.add('is-switching');
      setTimeout(function () {
        d.classList.remove('is-switching');
      }, 250);
    }
    d.open = true;
    setExpanded(d, true);
  }

  function anyOpen() {
    return all().some(function (o) {
      return o.open && !o.classList.contains('is-closing');
    });
  }

  function bind(d) {
    if (d.dataset.lkReady) return;
    d.dataset.lkReady = '1';
    var summary = d.querySelector('summary');
    if (!summary) return;

    d.addEventListener('mouseenter', function () {
      if (!canHover.matches) return;
      clearTimeout(d._lkLeave);
      clearTimeout(d._lkEnter);
      d._lkEnter = setTimeout(
        function () {
          if (!d.open || d.classList.contains('is-closing')) {
            open(d);
            d._lkHoverAt = Date.now();
          }
        },
        anyOpen() ? 0 : OPEN_DELAY
      );
    });

    d.addEventListener('mouseleave', function () {
      if (!canHover.matches) return;
      clearTimeout(d._lkEnter);
      d._lkLeave = setTimeout(function () {
        close(d);
      }, CLOSE_DELAY);
    });

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var willOpen;
      if (d.open && !d.classList.contains('is-closing')) {
        // Just opened by hovering? Keep it open instead of snapping shut.
        if (d._lkHoverAt && Date.now() - d._lkHoverAt < 700) {
          willOpen = true;
        } else {
          close(d);
          willOpen = false;
        }
      } else {
        open(d);
        willOpen = true;
      }
      d._lkHoverAt = 0;
      // Dawn also flips aria-expanded on click; set the final value after it.
      setTimeout(function () {
        setExpanded(d, willOpen);
      }, 0);
    });
  }

  function init() {
    all().forEach(bind);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('details.lk-mega')) return;
    all().forEach(function (d) {
      if (d.open) close(d);
    });
  });

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' && e.code !== 'Escape') return;
    all().forEach(function (d) {
      if (d.open) {
        closeNow(d);
        if (d.contains(document.activeElement)) d.querySelector('summary').focus();
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind when the header is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
